const STORAGE_KEY = 'beeylive:admin-color-scheme';
const isAdminColorScheme = (value) => value === 'light' || value === 'dark';
export const getAdminColorScheme = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return isAdminColorScheme(stored) ? stored : 'light';
    }
    catch {
        return 'light';
    }
};
export const setAdminColorScheme = (scheme) => {
    try {
        localStorage.setItem(STORAGE_KEY, scheme);
    }
    catch {
        // ignore quota / private mode
    }
};
